import router from '@/router'
import store from '@/store'
import p from '@/common/privilege'

const whiteList = ['/login', '/403', '/404'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  if (store.getters.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else if (whiteList.includes(to.path)) {
      next()
    } else {
      if (!store.getters.user) { // 验权
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          // if (p.checkPrivilegesByPath(store.getters.resValues, to.path)) {
          if (p.checkPrivileges(store.getters.resValues, to?.meta?.privileges ?? [])) {
            next()
          } else {
            next('/403')
          }
        })
      } else {
        // if (p.checkPrivilegesByPath(store.getters.resValues, to.path)) {
        if (p.checkPrivileges(store.getters.resValues, to?.meta?.privileges ?? [])) {
          next()
        } else {
          next('/403')
        }
      }
    }
  } else {
    // if (whiteList.indexOf(to.path) !== -1) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

// router.afterEach(() => {
// })
